import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaArrowLeft } from 'react-icons/fa';
import Select from 'react-select';
import transactionService from '../services/transactionService';
import currentAccountService from '../services/currentAccountService';

const TransactionFormPage = () => {
  const [formData, setFormData] = useState({
    current_account_id: '',
    transaction_type: 'borc',
    amount: '',
    description: '',
    due_date: '',
    status: 'bekliyor'
  });
  const [accounts, setAccounts] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const loadData = async () => {
      try {
        // Cari hesapları select box için çek
        const accs = await currentAccountService.getAll();
        setAccounts(accs);

        if (id) {
          // Düzenleme modu: Mevcut işlemi bul ve forma doldur
          const allTransactions = await transactionService.getAll();
          const transaction = allTransactions.find(t => t.id === parseInt(id));
          
          if (transaction) {
            // Tarih formatını input type="date" için ayarla (YYYY-MM-DD)
            const formattedDate = transaction.due_date ? new Date(transaction.due_date).toISOString().split('T')[0] : '';
            
            setFormData({
              current_account_id: transaction.current_account_id,
              transaction_type: transaction.transaction_type,
              amount: transaction.amount,
              description: transaction.description,
              due_date: formattedDate,
              status: transaction.status
            });
          }
        }
      } catch (error) {
        toast.error('Veriler yüklenirken hata oluştu.');
      }
    };
    loadData();
  }, [id]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.current_account_id) {
      toast.warning('Lütfen bir cari hesap seçiniz.');
      return;
    }

    try {
      // Tarih alanı boşsa null olarak gönder (Backend validasyonu için)
      const dataToSend = {
        ...formData,
        due_date: formData.due_date || null
      };

      if (id) {
        await transactionService.update(id, dataToSend);
        toast.success('İşlem güncellendi.');
      } else {
        await transactionService.create(dataToSend);
        toast.success('İşlem oluşturuldu.');
      }
      navigate('/transactions');
    } catch (error) {
      toast.error(error.response?.data?.message || 'İşlem başarısız.');
    }
  };

  const accountOptions = accounts.map(acc => ({ value: acc.id, label: acc.company_name }));

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex align-items-center mb-3">
        <button onClick={() => navigate(-1)} className="btn btn-outline-secondary">
          <FaArrowLeft className="me-2" /> Geri
        </button>
      </div>

      <div className="card shadow-sm">
        <div className="card-header bg-white">
          <h4 className="mb-0">{id ? 'İşlem Düzenle' : 'Yeni Borç/Alacak Ekle'}</h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Cari Hesap</label>
                <Select
                  options={accountOptions}
                  value={accountOptions.find(opt => opt.value === formData.current_account_id)}
                  onChange={(option) => setFormData({ ...formData, current_account_id: option ? option.value : '' })}
                  placeholder="Seçiniz..."
                  isDisabled={!!id}
                  isSearchable
                  isClearable
                  styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">İşlem Tipi</label>
                <select name="transaction_type" className="form-select" value={formData.transaction_type} onChange={handleChange}>
                  <option value="borc">Borç (Bize Borçlu)</option>
                  <option value="alacak">Alacak (Biz Borçluyuz)</option>
                </select>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Tutar (TL)</label>
                <input type="number" name="amount" className="form-control" value={formData.amount} onChange={handleChange} required min="0" step="0.01" />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Vade Tarihi</label>
                <input type="date" name="due_date" className="form-control" value={formData.due_date} onChange={handleChange} />
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">Açıklama</label>
                <textarea name="description" className="form-control" rows="3" value={formData.description} onChange={handleChange}></textarea>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button type="button" onClick={() => navigate(-1)} className="btn btn-secondary me-2">İptal</button>
              <button type="submit" className="btn btn-primary">Kaydet</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TransactionFormPage;